import React, { useContext } from 'react';
import SectionBlock from './SectionBlock';
import { IconCheckmarkL } from '../../../icons';
import { MatchingDialogContext } from '../configs';
import { distinguishBetweenMatchingEntries, getEntriesDictionary, showSection } from '../utils';
import { activities } from '../../../marketplace-custom-config';

const SectionInterests = () => {
    const {
        scoreData,
        categorySelected,
        horseImage,
        riderProfileImage,
        horseListing,
        riderListing,
    } = useContext(MatchingDialogContext);

    const interestAndActivityScore = scoreData?.baseScoreBreakdown?.interestAndActivityScore;

    if (!interestAndActivityScore) return null;

    const { shouldBeShown } = showSection({
        categorySelected,
        ...interestAndActivityScore,
    });

    if (!shouldBeShown) return null;

    const horseListingPublicData = horseListing?.attributes?.publicData || {};
    const riderListingPublicData = riderListing?.attributes?.publicData || {};

    const horseListingActivities = (horseListingPublicData['activities'] || []).map(entry => ({
        entry,
        image: horseImage,
    }));

    const riderListingActivities = (riderListingPublicData['activities'] || []).map(entry => ({
        entry,
        image: riderProfileImage,
    }));

    const entriesDictionary = [...riderListingActivities, ...horseListingActivities].reduce(
        getEntriesDictionary,
        {}
    );

    const { matchingEntries, nonMatchingEntries } = distinguishBetweenMatchingEntries(
        entriesDictionary,
        activities
    );

    return (
        <SectionBlock scoreData={scoreData}>
            <SectionBlock.Header>
                <IconCheckmarkL />
                <span>Interessen</span>
            </SectionBlock.Header>
            <SectionBlock.ScoreBadge sectionScoreData={interestAndActivityScore} />
            <section>
                {[...matchingEntries, ...nonMatchingEntries].map(
                    ([activityKey, { matches, images }], index, arr) => (
                        <>
                            <SectionBlock.ScoreLine
                                key={`activity-${index}`}
                                matches={matches}
                                lineLabel={activityKey}
                                avatars={images.map((image, index) => (
                                    <SectionBlock.ScoreLineAvatar
                                        key={`activity-image-${index}`}
                                        avatarUrl={image}
                                    />
                                ))}
                            />
                            {index < arr.length - 1 && <SectionBlock.Delimiter />}
                        </>
                    )
                )}
            </section>
        </SectionBlock>
    );
};

export default SectionInterests;
